import { AddressModule } from './address/address.module';
import { BasicInfoModule } from './basicInfo/basicInfo.module';
import { CompleteModule } from './complete/complete.module';
import { LoyaltyModule } from './loyalty/loyalty.module';
import { PaymentModule } from './payment/payment.module';

import { CompleteStepController } from './controllers/completeStepController';
import { PromoCodeController } from './controllers/promoCodeController';

import { PromoCodeComponent } from './directives/promoCodeComponent';

import { OrderInfoService } from './services/orderInfoService';
import { PromoCodeService } from './services/promoCodeService';

export const CheckoutStepsModule = angular
    .module('oo.checkout.checkoutSteps', [
        AddressModule,
        BasicInfoModule,
        CompleteModule,
        LoyaltyModule,
        PaymentModule
    ])
    .controller('CompleteStepController', CompleteStepController)
    .controller('PromoCodeController', PromoCodeController)

    .component('promoCode', PromoCodeComponent)

    .service('orderInfoService', OrderInfoService)
    .service('promoCodeService', PromoCodeService)

    .constant('ADDRESS_EVENTS', {
        ADDRESS_INVALID: 'ADDRESS_INVALID'
    })
    .name;
